"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Grid = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Box_1 = require("../Box");
function Grid(_a) {
    var { gap = 4, columnGap, rowGap, templateColumns } = _a, props = __rest(_a, ["gap", "columnGap", "rowGap", "templateColumns"]);
    return (jsx_runtime_1.jsx(Box_1.Box, Object.assign({ display: "grid", gridGap: gap, gridRowGap: rowGap, gridColumnGap: columnGap, gridTemplateColumns: templateColumns }, props), void 0));
}
exports.Grid = Grid;
//# sourceMappingURL=index.js.map